import AssetCardFormModal from "./AssetCardFormModal";

export const EditAssetCard = ({ assetId, refresh, setState, onAlert }) => (
  <AssetCardFormModal mode="edit" assetId={assetId} refresh={refresh} setState={setState} onAlert={onAlert} />
);
